import toast from 'react-hot-toast';

class ErrorHandlerService {
  private networkErrorTimeout: NodeJS.Timeout | null = null;

  showNetworkError() {
    // If there's an existing timeout, clear it
    if (this.networkErrorTimeout) {
      clearTimeout(this.networkErrorTimeout);
      this.networkErrorTimeout = null;
    }

    // Show the toast
    toast.error('Network error. Please check your internet connection and try again.', {
      position: 'bottom-left',
      duration: 5000, // Show for 5 seconds
      id: 'network-error', // Unique ID for the network error toast
      style: {
        background: '#fee2e2', // Light red background
        color: '#991b1b', // Dark red text
        border: '1px solid #fecaca',
        padding: '16px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
      },
      iconTheme: {
        primary: '#dc2626',
        secondary: '#fee2e2',
      },
    });

    // Set a new timeout to prevent showing another network error toast for 5 seconds
    this.networkErrorTimeout = setTimeout(() => {
      this.networkErrorTimeout = null;
    }, 5000);
  }

  // Add other error handling methods as needed
  showError(message: string) {
    toast.error(message, {
      position: 'bottom-left',
      duration: 4000,
      style: {
        background: '#fee2e2',
        color: '#991b1b',
        border: '1px solid #fecaca',
        padding: '16px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
      },
    });
  }
}

export const errorHandler = new ErrorHandlerService();
